import { ADD_NAMESPACE } from '../types';
import { createAxiosAction } from '../utils';

export default {
  addNamespace: (projectId, name) => {
    return createAxiosAction({
      url: `/api/v1/namespaces`,
      body: {
        projectId,
        name,
      },
      method: 'POST',
      startAction: ADD_NAMESPACE,
    });
  },
  deleteNamespace: namespaceId => {
    return createAxiosAction({
      url: `/api/v1/namespaces/${namespaceId}`,
      method: 'DELETE',
      startAction: 'DELETE_NAMESPACE',
    });
  },
};
